
import axios from 'axios'

const baseUrl = '/api/Configuration/';

export const configurationService = {
    getConfiguration,
};

async function getConfiguration() {
    let result = await axios.get(`${baseUrl}GetConfiguration`);
    return result.data;
}